import numeral from 'numeral';

var abbreviate = function abbreviate(value) {
  return numeral(value).format('0.0a');
};

var bytes = function bytes(value) {
  return numeral(value).format('0 b');
};

var exposedNumeral = function exposedNumeral(value, format) {
  return numeral(value).format(format);
};

var exponential = function exponential(value) {
  return numeral(value).format('0.[00]e+0');
};

var ordinal = function ordinal(value) {
  return numeral(value).format('Oo');
};

var percentage = function percentage(value) {
  return numeral(value).format('0.[00]%');
};

var separator = function separator(value) {
  return numeral(value).format('0,0.00');
};

var separatorInt = function separatorInt(value) {
  return numeral(value).format('0,0');
};

var currency = function currency(value) {
  return numeral(value).format('$0,0.00');
};

export { abbreviate, bytes, exponential, exposedNumeral, ordinal, percentage, separator, separatorInt, currency };